/* RestoreEarth free gifts.
   The silk sleep mask and the sheet-care bags are $0 products that come with
   every grounding sheet order. This file keeps that promise honest:
   - adding a grounding sheet from its product page also adds the two gifts;
   - the cart never holds more than one of each gift;
   - the gifts are removed if no grounding sheet is left in the cart.
   To change which products qualify or which gifts are added, edit the lists
   below. */
(function () {
  'use strict';

  // Products that qualify for the free gifts (grounding sheets).
  var SHEET_PRODUCT_IDS = [8871621591214, 8910986608814];
  var SHEET_HANDLES = ['restoreearth™-sheets', 'grounding-anti-static-bed-sheet-60x265cm-1'];
  // Gift variants added with a sheet: silk sleep mask (Black), sheet-care bags (2 X Extra Large).
  var GIFT_VARIANT_IDS = [67652859920558, 67652910088366];

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function refreshDrawer() {
    return fetch(root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-content]');
        var current = document.querySelector('[data-cart-drawer-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count < 1;
        });
        return cart;
      })
      .catch(function () {});
  }
  function openDrawer() {
    if (!document.getElementById('cart-drawer')) { window.location.href = root + 'cart'; return; }
    // The theme opens drawers from any [data-drawer-open] click, so borrow that.
    var b = document.createElement('button');
    b.type = 'button';
    b.hidden = true;
    b.setAttribute('data-drawer-open', 'cart-drawer');
    document.body.appendChild(b);
    b.click();
    b.parentNode.removeChild(b);
  }
  window.reAfterAdd = function () {
    return refreshDrawer().then(refreshCount).then(openDrawer);
  };

  /* ---------- Cart guard ----------
     The cart drawer and cart page print a hidden [data-re-giftfix] marker
     ("lineKey:qty,lineKey:qty,") whenever a gift line needs correcting. */
  var busy = false;
  function applyFix(el) {
    if (busy) return;
    var spec = el.getAttribute('data-re-giftfix') || '';
    el.removeAttribute('data-re-giftfix');
    var updates = {}, n = 0;
    spec.split(',').forEach(function (pair) {
      if (!pair) return;
      var i = pair.lastIndexOf(':');
      if (i < 1) return;
      updates[pair.slice(0, i)] = parseInt(pair.slice(i + 1), 10) || 0;
      n++;
    });
    if (!n) return;
    busy = true;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () {
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        return refreshDrawer().then(refreshCount);
      })
      .catch(function () {})
      .then(function () { busy = false; scan(); });
  }
  function scan() {
    var el = document.querySelector('[data-re-giftfix]');
    if (el) applyFix(el);
  }

  /* ---------- Product page ----------
     On a grounding sheet's page, add-to-cart sends the sheet, any ticked
     add-ons and the two gifts in one request. Runs in the capture phase on
     the document, so it takes over before the theme's own handlers. */
  function currentProductId() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (m && m.id) return parseInt(m.id, 10);
    } catch (e) {}
    return 0;
  }
  function onSheetPage() {
    var pid = currentProductId();
    if (pid) return SHEET_PRODUCT_IDS.indexOf(pid) > -1;
    var path = '';
    try { path = decodeURIComponent(window.location.pathname); } catch (e) { path = window.location.pathname; }
    var m = path.match(/\/products\/([^\/?#]+)/);
    return !!(m && SHEET_HANDLES.indexOf(m[1]) > -1);
  }

  function hideExpressButtons() {
    // Express buttons (Shop Pay, Apple Pay) buy the sheet alone and skip the
    // gifts. Express payment is still offered on the checkout page.
    Array.prototype.forEach.call(document.querySelectorAll('form[data-product-form] .shopify-payment-button'), function (el) {
      el.style.display = 'none';
    });
  }

  function postItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
  }

  function init() {
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

    if (!onSheetPage()) return;
    hideExpressButtons();
    new MutationObserver(hideExpressButtons).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('form[data-product-form]') : null;
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var idEl = form.querySelector('[data-variant-id]') || form.querySelector('[name="id"]');
      var mainId = idEl ? parseInt(idEl.value, 10) : 0;
      if (!mainId) return;
      var base = [{ id: mainId, quantity: 1 }];
      Array.prototype.forEach.call(document.querySelectorAll('[data-re-add][aria-pressed="true"]'), function (r) {
        var aid = parseInt(r.getAttribute('data-re-add'), 10);
        if (aid) base.push({ id: aid, quantity: 1 });
      });
      var withGifts = base.concat(GIFT_VARIANT_IDS.map(function (g) { return { id: g, quantity: 1 }; }));

      var btn = form.querySelector('[data-atc]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding…'; }
      var done = function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; } };

      postItems(withGifts)
        .then(function (res) {
          // If a gift can't be added for any reason, never block the sheet itself.
          if (!res.ok) return postItems(base);
          return res;
        })
        .then(function (res) {
          done();
          if (!res.ok) {
            if (window.themeToast) window.themeToast(res.d.description || res.d.message || 'Could not add to cart.');
            return;
          }
          return window.reAfterAdd();
        })
        .catch(function () {
          done();
          if (window.themeToast) window.themeToast('Something went wrong. Please try again.');
        });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
